module.exports = __webpack_public_path__ + "font-awesome.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/font-awesome/font-awesome.woff?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.woff?v=4.7.0
// module chunks = 5